module.exports = __webpack_public_path__ + "e7cfd9c94e65f55b884d9b78a3cdecd2.ico";